export default "__VITE_ASSET__EA$kcXd6__"